import "./CSS_styles/heading.css";

export default function ToggleSwitch({ checked, onChange, label }) {
  return (
    <label className="toggle-wrap" aria-label={label}>
      <input
        className="toggle-input"
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="toggle-track" />
    </label>
  );
}